import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initWebVitals } from "./lib/web-vitals";
import "./index.css";
initWebVitals();
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
